import userServices from '@/services/myAccount/userServices';
import * as types from './actionTypes';
import { authenticationService } from '@/services/authentication_service';

export function fetchProfileData() {
    return async (dispatch: any, getState: any) => {
        let profileData;
        try {
            profileData = await userServices.fetchUserProfile();
            if (authenticationService.isLoggedIn() && profileData?.id) {
                dispatch({ type: types.PROFILE_DATA_FETCHED, profileData });
            } else {
                profileData = { error: true };
                dispatch({
                    type: types.PROFILE_DATA_FETCH_FAILED,
                    profileData,
                });
            }
        } catch (error) {
            profileData = { error: true };
            dispatch({ type: types.PROFILE_DATA_FETCH_FAILED, profileData });
        }
    };
}

export const clearProfileData = () => {
    return async (dispatch: any) => {
        dispatch({
            type: types.CLEAR_PROFILE_DATA,
        });
    };
};
